import React, {PureComponent} from 'react';
import styled, {keyframes} from 'styled-components';
import merge from 'react-animations/lib/merge';

// Import each of the animations used in the app. Anything from animate.css is valid.
import slideInUp from 'react-animations/lib/slide-in-up';
import slideOutDown from 'react-animations/lib/slide-out-down';
import slideInLeft from 'react-animations/lib/slide-in-left';
import slideOutLeft from 'react-animations/lib/slide-out-left';
import slideInRight from 'react-animations/lib/slide-in-right';
import slideOutRight from 'react-animations/lib/slide-out-right';
import fadeIn from 'react-animations/lib/fade-in';
import fadeOut from 'react-animations/lib/fade-out';

export const ANIMATION_MAP = {
  'slide-in-up': slideInUp,
  'slide-out-down': slideOutDown,
  'slide-in-left': slideInLeft,
  'slide-out-left': slideOutLeft,
  'slide-in-right': slideInRight,
  'slide-out-right': slideOutRight,
  'fade-in': fadeIn,
  'fade-out': fadeOut
};

class VisibilityAnimation extends PureComponent {
  state = {
    showing: this.props.visible,
    transitioning: false
  };

  static getDerivedStateFromProps(props, state) {
    if (props.visible && !state.showing) {
      return {
        showing: true,
        transitioning: true
      };
    }
    else if (!props.visible && state.showing) {
      return {
        showing: false,
        transitioning: true
      };
    }

    return null;
  }

  handleAnimationEnd = (...args) => {
    const {onAnimationEnd} = this.props;

    this.setState({
      transitioning: false
    }, () => onAnimationEnd && onAnimationEnd(...args));
  }

  render() {
    const {show, hide, duration = '0.2s', curve = 'ease-in-out', children, ...props} = this.props;
    const {showing, transitioning} = this.state;
    const animation = showing ? getAnimation(show) : getAnimation(hide);

    return (
      <Container 
        {...props} 
        duration={duration} 
        curve={curve} 
        animation={animation} 
        onAnimationEnd={this.handleAnimationEnd}>
        {(showing || transitioning) && children}
      </Container>
    );
  }
}

function getAnimation(animations) {
  if (!Array.isArray(animations)) {
    return ANIMATION_MAP[animations];
  }

  return animations.reduce((merged, animation) => {
    if (!ANIMATION_MAP[animation]) {
      throw new Error(`No such animation: ${animation}. Did you forget to import it?`);
    }

    if (!merged) {
      return ANIMATION_MAP[animation];
    }

    return merge(merged, ANIMATION_MAP[animation]);
  }, null);
}

const Container = styled.div`
  animation: ${props => props.duration} ${props => keyframes`${props.animation}`};
  animation-timing-function: ${props => props.curve};
`;

export default VisibilityAnimation;